import Footer from '@/components/Footer';
import { BizAward, BizCta, BizEmployees, BizEnterprise, BizHR, BizInquiry, BizIntroduction, BizPlan, BizReview } from '@/module/biz-landing/components';
export const BizLanding = () => {
  return <div className="flex flex-col gap-md min-[751px]:gap-2xl min-[1025px]:gap-3xl" data-sentry-component="BizLanding" data-sentry-source-file="BizLanding.tsx">
      <BizCta data-sentry-element="BizCta" data-sentry-source-file="BizLanding.tsx" />
      <BizIntroduction data-sentry-element="BizIntroduction" data-sentry-source-file="BizLanding.tsx" />
      <BizAward data-sentry-element="BizAward" data-sentry-source-file="BizLanding.tsx" />
      <BizReview data-sentry-element="BizReview" data-sentry-source-file="BizLanding.tsx" />
      <BizHR data-sentry-element="BizHR" data-sentry-source-file="BizLanding.tsx" />
      <BizEmployees data-sentry-element="BizEmployees" data-sentry-source-file="BizLanding.tsx" />
      <BizEnterprise data-sentry-element="BizEnterprise" data-sentry-source-file="BizLanding.tsx" />
      <div className="flex flex-col bg-gradient-to-b from-gray-100 to-gray-50">
        <BizPlan data-sentry-element="BizPlan" data-sentry-source-file="BizLanding.tsx" />
        <BizInquiry data-sentry-element="BizInquiry" data-sentry-source-file="BizLanding.tsx" />
      </div>
      <Footer data-sentry-element="Footer" data-sentry-source-file="BizLanding.tsx" />
    </div>;
};